import styles from "./selectitem.module.css"

export default function SelectItem({itemId,setName,value}){
    return(
        <div className={styles.item} onClick={ ()=> setName(itemId, value)}>
            <span className="annotation uppercase">{value}</span>
        </div>
    );
}